module.exports = __webpack_public_path__ + "img/daNang.ff8779f4.jpg";